// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-overview-by-type-light-widget{height:100%}`, "",{"version":3,"sources":["webpack://./src/elements/report-widgets/portfolio-overview-by-type-light-widget/portfolio-overview-by-type-light-widget.scss"],"names":[],"mappings":"AAAA,yCAAyC,WAAW","sourcesContent":[".portfolio-overview-by-type-light-widget{height:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
